import script from "./cooperation.vue?vue&type=script&setup=true&lang=js"
export * from "./cooperation.vue?vue&type=script&setup=true&lang=js"

import "./cooperation.vue?vue&type=style&index=0&id=396df9e6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-396df9e6"]])

export default __exports__